import { useMemo } from "react";
import { Token } from "store/global/TokenEnum";
import { TokenMetadata } from "store/global/getTokenMetadata";
import { ActivityStore } from "../store/activity/ActivityStore";
import { TokenHistoryInfo } from "../types/history";

export const useUserTradedTokens = () => {
  const history = ActivityStore.useState(s => s.history);
  const tokenMetadata = ActivityStore.useState(s => s.tokens);

  /*
    Groups the data returned from getHistory.ts by Month
    This is so we can show the Month/Year above the trades which were made in that Month/year.
   */
  const userTradedTokens = useMemo(() => {
    if (history.data === undefined) return []; // populate skeletons in table if history not returned yet
    if (history.error != null) return []; // populate skeletons in table if history not returned yet
    const transactions = Object.values(history.data.results);
    const tokenSet = new Set<Token>();

    transactions.forEach(transaction => {
      const { sellTokens, buyTokens } = transaction;
      addTokensToSet(sellTokens);
      addTokensToSet(buyTokens);
    });

    function addTokensToSet(tokens: TokenHistoryInfo) {
      if (tokens) {
        const tokenKeys = Object.keys(tokens) as Array<Token>;
        tokenKeys.forEach(token => {
          tokenSet.add(token);
        });
      }
    }

    const tokenList = Array.from(tokenSet);
    const tokenData: { [key in Token]?: TokenMetadata[key] } = {};

    tokenList.forEach(token => {
      const tokenMetadataItem = tokenMetadata?.[token];
      if (tokenMetadataItem) {
        tokenData[token] = tokenMetadataItem;
      }
    });

    return tokenData;
  }, [history, tokenMetadata]);
  return userTradedTokens;
};
